import { render, staticRenderFns } from "./DrmSettings.vue?vue&type=template&id=f8de9ba2&"
import script from "./DrmSettings.vue?vue&type=script&lang=js&"
export * from "./DrmSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports